(function(){
  document.addEventListener('DOMContentLoaded', function() {
    /*
    * start code for hover menu open
    */
    const inlineMenu = document.querySelectorAll(".header__inline-menu");
    const detailsItems = document.querySelectorAll(".header__inline-menu header-menu > details");
      detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul");
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
          item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        });
      });
    /*
    * end start code for hover menu open
    */

    /*
    * do summary menu clickable
    */
    const summaryMenu = document.querySelectorAll(".header__inline-menu header-menu > details > summary");
    summaryMenu.forEach(elem => {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        if ( elem.dataset.link ) {
          window.location.href = elem.dataset.link;
        }
      });
    });

  }, false);
})();